<template>
  <autoit-sales-widget-trigger>
    <div @click.prevent="onlineSalesLinktrigger()" class="online-sales-button">
      Køb online
    </div>
  </autoit-sales-widget-trigger>
</template>

<script>
import { OnlineSalesClicked } from '@/events'

export default {
  props: {
    origin: { default: '', type: String },
  },
  methods: {
    onlineSalesLinktrigger() {
      OnlineSalesClicked(this.origin)
    },
  },
}
</script>
